import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const sliderdata = [
  {
    slider_img: "images/Currentlive01.png",
  },
  {
    slider_img: "images/Currentlive02.png",
  },
  {
    slider_img: "images/Currentlive03.png",
  },
  {
    slider_img: "images/Currentlive04.png",
  },
  {
    slider_img: "images/Currentlive05.png",
  },
  {
    slider_img: "images/Currentlive01.png",
  },
  {
    slider_img: "images/Currentlive01.png",
  },
  {
    slider_img: "images/Currentlive02.png",
  },
  {
    slider_img: "images/Currentlive03.png",
  },
  {
    slider_img: "images/Currentlive04.png",
  },
];

export default function Profilereviewtab() {
  const [state, setState] = useState({ tab: "tab1" });
  return (
    <section className="Browsemuseums Termscenter">
      <Container>
        <div className="tabbing-profile">
          <div className="tab-frame profile-frame">
            <div className="clearfix">
              <input
                type="radio"
                name="tab"
                id="tab1"
                checked={state.tab == "tab1"}
                onClick={() => setState({ tab: "tab1" })}
              />
              <label htmlFor="tab1">On Sale</label>

              <input
                type="radio"
                name="tab"
                id="tab2"
                checked={state.tab == "tab2"}
                onClick={() => setState({ tab: "tab2" })}
              />
              <label htmlFor="tab2">Upcoming NFT’s</label>

              <input
                type="radio"
                name="tab"
                id="tab3"
                checked={state.tab == "tab3"}
                onClick={() => setState({ tab: "tab3" })}
              />
              <label htmlFor="tab3">Owned </label>

              <input
                type="radio"
                name="tab"
                id="tab4"
                checked={state.tab == "tab4"}
                onClick={() => setState({ tab: "tab4" })}
              />
              <label htmlFor="tab4">Sold</label>
            </div>

            {state.tab == "tab1" && (
              <div className="reviwtab-profile mt-5">
                <ul>
                  {sliderdata.map((item, idx) => {
                    return (
                      <li key={idx}>
                        <div>
                          <div className="digital-art-wrap">
                            <div className="currentlive-art-img position-relative">
                              <img
                                src={item.slider_img}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <div className="currentlive-art-content">
                              <h5>Decentraland Logo Earrings</h5>

                              <div className="bidwith-name">
                                <div className="name-wrapping">
                                  <h3>
                                    Hyberbear{" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="13"
                                      height="13"
                                      viewBox="0 0 9 9"
                                      fill="none"
                                    >
                                      <path
                                        d="M8.2358 4.39329L7.34577 3.32713L7.46979 1.91705L6.15298 1.6037L5.46357 0.380859L4.22337 0.938778L2.98316 0.380859L2.29375 1.59987L0.976947 1.9094L1.10097 3.32331L0.210938 4.39329L1.10097 5.45945L0.976947 6.87335L2.29375 7.18671L2.98316 8.40572L4.22337 7.84398L5.46357 8.4019L6.15298 7.18288L7.46979 6.86953L7.34577 5.45945L8.2358 4.39329ZM3.52666 6.19697L2.14055 4.74103L2.68041 4.17547L3.52666 5.06585L5.66055 2.82271L6.2004 3.38827L3.52666 6.19697Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </h3>
                                  <p>Top Bid</p>
                                </div>
                                <Button className="buy-now-btn">Buy Now</Button>
                              </div>

                              <div className="auction-price">
                                <p>25.888 USD</p>
                                <img
                                  src="images/eth.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {state.tab == "tab2" && (
              <div className="reviwtab-profile mt-5">
                <ul>
                  {sliderdata.map((item, idx) => {
                    return (
                      <li key={idx}>
                        <div>
                          <div className="digital-art-wrap upcomimg-aution">
                            <div className="currentlive-art-img position-relative">
                              <img
                                src={item.slider_img}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <div className="upcomimg-art-content">
                              <div className="upcoming-auction-timimg">
                                <div className="comon0timg-div">
                                  <p className="fade-col">Decentraland </p>
                                  <p className="dard-col">25.888 USD</p>
                                </div>
                                <div className="comon0timg-div">
                                  <p className="fade-col">Auction Start </p>
                                  <p className="dard-col">07h : 25m :46s</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {state.tab == "tab3" && (
              <div className="reviwtab-profile mt-5">
                <ul>
                  {sliderdata.map((item, idx) => {
                    return (
                      <li key={idx}>
                        <div>
                          <div className="digital-art-wrap upcomimg-aution">
                            <div className="currentlive-art-img position-relative">
                              <img
                                src={item.slider_img}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <div className="upcomimg-art-content">
                              <h5 className="owenedcard-head">
                                Decentraland Logo Earrings
                              </h5>

                              <div className="user-partwrap">
                                <div className="user-part">
                                  <div className="avatr-user position-relative">
                                    <img
                                      src="images/user2.png"
                                      alt=""
                                      className="img-fluid"
                                    />
                                    <div className="verified">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                      >
                                        <path
                                          d="M10 5L8.89091 3.67143L9.04545 1.91429L7.40455 1.52381L6.54545 0L5 0.695238L3.45455 0L2.59545 1.51905L0.954545 1.90476L1.10909 3.66667L0 5L1.10909 6.32857L0.954545 8.09048L2.59545 8.48095L3.45455 10L5 9.3L6.54545 9.99524L7.40455 8.47619L9.04545 8.08571L8.89091 6.32857L10 5ZM4.13182 7.24762L2.40455 5.43333L3.07727 4.72857L4.13182 5.8381L6.79091 3.04286L7.46364 3.74762L4.13182 7.24762Z"
                                          fill="#119AE7"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                  <h3>
                                    Hyberbear{" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="13"
                                      height="13"
                                      viewBox="0 0 9 9"
                                      fill="none"
                                    >
                                      <path
                                        d="M8.2358 4.39329L7.34577 3.32713L7.46979 1.91705L6.15298 1.6037L5.46357 0.380859L4.22337 0.938778L2.98316 0.380859L2.29375 1.59987L0.976947 1.9094L1.10097 3.32331L0.210938 4.39329L1.10097 5.45945L0.976947 6.87335L2.29375 7.18671L2.98316 8.40572L4.22337 7.84398L5.46357 8.4019L6.15298 7.18288L7.46979 6.86953L7.34577 5.45945L8.2358 4.39329ZM3.52666 6.19697L2.14055 4.74103L2.68041 4.17547L3.52666 5.06585L5.66055 2.82271L6.2004 3.38827L3.52666 6.19697Z"
                                        fill="black"
                                      ></path>
                                    </svg>
                                  </h3>
                                </div>
                                <img
                                  src="images/eth.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>

                              <div className="btn-sell">
                                <Button className="sellitem">sale Item</Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {state.tab == "tab4" && (
              <div className="reviwtab-profile mt-5">
                <ul>
                  {sliderdata.map((item, idx) => {
                    return (
                      <li key={idx}>
                        <div>
                          <div className="digital-art-wrap">
                            <div className="currentlive-art-img position-relative">
                              <img
                                src={item.slider_img}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <div className="currentlive-art-content">
                              <h5>Decentraland Logo Earrings</h5>

                              <div className="bidwith-name">
                                <div className="name-wrapping">
                                  <h3>
                                    Hyberbear{" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="13"
                                      height="13"
                                      viewBox="0 0 9 9"
                                      fill="none"
                                    >
                                      <path
                                        d="M8.2358 4.39329L7.34577 3.32713L7.46979 1.91705L6.15298 1.6037L5.46357 0.380859L4.22337 0.938778L2.98316 0.380859L2.29375 1.59987L0.976947 1.9094L1.10097 3.32331L0.210938 4.39329L1.10097 5.45945L0.976947 6.87335L2.29375 7.18671L2.98316 8.40572L4.22337 7.84398L5.46357 8.4019L6.15298 7.18288L7.46979 6.86953L7.34577 5.45945L8.2358 4.39329ZM3.52666 6.19697L2.14055 4.74103L2.68041 4.17547L3.52666 5.06585L5.66055 2.82271L6.2004 3.38827L3.52666 6.19697Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </h3>
                                  <p>Top Bid</p>
                                </div>
                                <div className="auction-pricessold">
                                  <p>25.888 USD</p>
                                  <img
                                    src="images/eth.png"
                                    alt=""
                                    className="img-fluid"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="text-center show-wrap">
          <button type="button" className="showmore btn btn-primary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                opacity="0.5"
                d="M11.7425 2.60254C9.86406 2.60254 8.02785 3.15955 6.46602 4.20313C4.90419 5.24671 3.68689 6.72999 2.96806 8.4654C2.24923 10.2008 2.06115 12.1104 2.42761 13.9527C2.79407 15.795 3.6986 17.4873 5.02683 18.8155C6.35505 20.1437 8.04731 21.0483 9.88962 21.4147C11.7319 21.7812 13.6415 21.5931 15.3769 20.8743C17.1123 20.1554 18.5956 18.9381 19.6392 17.3763C20.6828 15.8145 21.2398 13.9783 21.2398 12.0999C21.2398 10.8527 20.9941 9.61767 20.5168 8.4654C20.0396 7.31313 19.34 6.26615 18.4581 5.38424C17.5762 4.50233 16.5292 3.80277 15.3769 3.32548C14.2247 2.84819 12.9897 2.60254 11.7425 2.60254ZM11.7425 19.6977C10.2397 19.6977 8.77077 19.2521 7.5213 18.4173C6.27184 17.5824 5.29801 16.3958 4.72294 15.0074C4.14788 13.6191 3.99741 12.0914 4.29058 10.6176C4.58374 9.14376 5.30737 7.78995 6.36995 6.72737C7.43253 5.66479 8.78634 4.94116 10.2602 4.648C11.734 4.35483 13.2617 4.50529 14.65 5.08036C16.0384 5.65542 17.225 6.62926 18.0598 7.87872C18.8947 9.12819 19.3403 10.5972 19.3403 12.0999C19.3403 14.115 18.5398 16.0475 17.115 17.4724C15.6901 18.8972 13.7575 19.6977 11.7425 19.6977Z"
                fill="white"
              ></path>
              <path
                d="M19.341 12.0999H21.2405C21.2405 10.8527 20.9948 9.61767 20.5176 8.4654C20.0403 7.31313 19.3407 6.26615 18.4588 5.38424C17.5769 4.50233 16.5299 3.80277 15.3776 3.32548C14.2254 2.84819 12.9904 2.60254 11.7432 2.60254V4.50201C13.7582 4.50201 15.6908 5.30249 17.1157 6.72737C18.5405 8.15224 19.341 10.0848 19.341 12.0999Z"
                fill="white"
              ></path>
            </svg>
            Show Me More
          </button>
        </div>
      </Container>
    </section>
  );
}
